(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (() => {
    const KEY = 'ss-recent-searches';
    const MAX = 6;

    const read = () => {
      try {
        const list = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    };

    const write = (list) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {}
    };

    const init = () => {
      const root = document.querySelector('[data-ss-search]');
      if (!root) return;

      const query = (root.dataset.query || '').trim();
      const url = root.dataset.searchUrl;

      if (query && root.dataset.hasResults === 'true') {
        const next = [query, ...read().filter((q) => q.toLowerCase() !== query.toLowerCase())].slice(0, MAX);
        write(next);
      }

      const wrap = root.querySelector('[data-ss-recent]');
      const list = root.querySelector('[data-ss-recent-list]');
      if (wrap && list) {
        const render = () => {
          const items = read();
          list.textContent = '';
          items.forEach((q) => {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.className = 'ss-search__chip';
            a.href = url + '?q=' + encodeURIComponent(q) + '&options[prefix]=last';
            a.textContent = q;
            li.appendChild(a);
            list.appendChild(li);
          });
          wrap.hidden = items.length === 0;
        };

        render();

        const clear = root.querySelector('[data-ss-recent-clear]');
        if (clear) {
          clear.addEventListener('click', () => {
            write([]);
            render();
          });
        }
      }

      const input = root.querySelector('input[name="q"]');
      if (input && !input.value) input.focus({ preventScroll: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-collection-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ssf__q');
    if (!btn) return;
    var item = btn.closest('.ssf__item');
    var open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-collection-new"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__ssxInit) return;
      root.__ssxInit = true;
      root.addEventListener('click', function (e) {
        var sw = e.target.closest && e.target.closest('.ssx__sw');
        if (!sw) return;
        var item = sw.closest('[data-ssx-item]');
        if (!item) return;
        item.querySelectorAll('.ssx__sw').forEach(function (b) { b.classList.toggle('is-on', b === sw); b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'); });
        var colour = sw.getAttribute('data-colour') || '';
        var img = item.querySelector('.ssx__img--main img');
        var src = sw.getAttribute('data-image');
        if (img && src) {
          var next = new Image();
          next.onload = function () { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; if (next.naturalWidth && img.parentElement) img.parentElement.style.aspectRatio = next.naturalWidth + ' / ' + next.naturalHeight; };
          next.src = src;
        }
        var url = sw.getAttribute('data-url');
        if (url) item.querySelectorAll('[data-ssx-link]').forEach(function (a) { a.setAttribute('href', url); });
        var add = item.querySelector('[data-quick-add]');
        if (add) add.setAttribute('data-colour', colour);
        var label = item.querySelector('[data-ssx-colour-name]');
        if (label) label.textContent = colour;
      });
    }
    function boot() { document.querySelectorAll('[data-ssx]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-footer"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-ss-footer-select]');
    if (select && select.form) select.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__sshInit) return;
      root.__sshInit = true;
      var vp = root.querySelector('.ssh__viewport');
      var slides = [].slice.call(root.querySelectorAll('[data-ssh-slide]'));
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var advanceOnEnd = root.getAttribute('data-advance-on-end') === 'true';
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var phone = window.matchMedia('(max-width: 749px)');
      var muted = true;
      var current = 0, timer = null, userPaused = false, hoverPaused = false, visible = true;
      if (reduce) autoplay = false;

      // The hero is as tall as the slide in view
      function fit() { var h = slides[current] && slides[current].offsetHeight; if (h && Math.abs(h - (parseFloat(vp.style.height) || 0)) > 1) vp.style.height = h + 'px'; }
      slides.forEach(function (s) {
        s.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', fit); });
        s.querySelectorAll('video').forEach(function (v) { v.addEventListener('loadedmetadata', fit); });
      });
      window.addEventListener('resize', fit, { passive: true });

      function rtl() { return getComputedStyle(vp).direction === 'rtl'; }
      function activeVideo(slide) { return slide.querySelector(phone.matches ? '.ssh__video--mobile' : '.ssh__video--desktop') || slide.querySelector('video'); }

      function goTo(i, instant) {
        i = (i + slides.length) % slides.length;
        vp.scrollTo({ left: rtl() ? -(i * vp.clientWidth) : i * vp.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      }

      function stopTimer() { clearTimeout(timer); timer = null; root.classList.remove('is-timing'); }
      function canRun() { return autoplay && !userPaused && !hoverPaused && visible && slides.length > 1; }

      function startTimer() {
        stopTimer();
        if (!canRun()) return;
        var slide = slides[current];
        var v = slide.getAttribute('data-has-video') === 'true' ? activeVideo(slide) : null;
        // A video slide plays to its end (when asked); everything else waits the set time
        if (v && advanceOnEnd && isFinite(v.duration) && v.duration > 0) {
                    v.loop = false;
          v.onended = function () { v.onended = null; v.loop = true; if (canRun()) goTo(current + 1); };
          return;
        }
        if (v && advanceOnEnd && (!isFinite(v.duration) || !v.duration)) {
          v.addEventListener('loadedmetadata', function once() { v.removeEventListener('loadedmetadata', once); startTimer(); });
          v.load();
          return;
        }
        timer = setTimeout(function () { goTo(current + 1); }, interval);
      }

      function playActive() {
        slides.forEach(function (s, idx) {
          var vids = s.querySelectorAll('video');
          vids.forEach(function (v) {
            if (idx === current && v === activeVideo(s) && !reduce && !userPaused) {
              v.muted = muted;
              v.preload = 'auto';
              var p = v.play(); if (p && p.catch) p.catch(function () {});
            } else {
              v.pause();
              if (idx !== current) { try { v.currentTime = 0; } catch (e) {} }
            }
          });
        });
      }

      function setCurrent(i) {
        if (i === current && root.__ready) return;
        current = i;
        root.__ready = true;
        slides.forEach(function (s, idx) { s.setAttribute('aria-hidden', idx === current ? 'false' : 'true'); });
        // warm up the next video
        var nxt = slides[(current + 1) % slides.length];
        var nv = nxt && nxt.querySelector('video'); if (nv && nv.preload === 'none') nv.preload = 'metadata';
        fit();
        syncControls();
        playActive();
        startTimer();
      }

      // Update only once the swipe has settled on a slide, so the browser's own snap scrolling is never fought mid-swipe
      var settle = null;
      function onSettled() {
        var i = Math.round(Math.abs(vp.scrollLeft) / (vp.clientWidth || 1));
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (i !== current) setCurrent(i);
      }
      vp.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(onSettled, 120);
      }, { passive: true });
      if ('onscrollend' in window) vp.addEventListener('scrollend', function () { clearTimeout(settle); onSettled(); });

      vp.addEventListener('keydown', function (e) {
        var step = rtl() ? -1 : 1;
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + step); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - step); }
      });

      var prevBtn = root.querySelector('[data-ssh-prev]'), nextBtn = root.querySelector('[data-ssh-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
      var playBtn = root.querySelector('[data-ssh-play]');
      var soundBtn = root.querySelector('[data-ssh-sound]');
      if (playBtn) playBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        playBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        playBtn.setAttribute('aria-label', userPaused ? 'Play' : 'Pause');
        root.classList.toggle('is-paused', userPaused);
        if (userPaused) { stopTimer(); slides.forEach(function (s) { s.querySelectorAll('video').forEach(function (v) { v.pause(); }); }); }
        else { playActive(); startTimer(); }
      });
      if (soundBtn) soundBtn.addEventListener('click', function () {
        muted = !muted;
        soundBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
        soundBtn.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
        root.classList.toggle('is-unmuted', !muted);
        slides.forEach(function (s) { s.querySelectorAll('video').forEach(function (v) { v.muted = muted; }); });
        playActive();
      });
      // The sound button only shows on a slide that has a video
      function syncControls() {
        if (soundBtn) soundBtn.hidden = slides[current].getAttribute('data-has-video') !== 'true';
        // On desktop, when the header sits over the hero, drop the buttons below it
        var hdr = document.querySelector('.header-wrapper--sticky');
        var below = hdr && root.getBoundingClientRect().top < (hdr.getBoundingClientRect().bottom || 0);
        root.style.setProperty('--ssh-top', below ? ((parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 90) + 14) + 'px' : '16px');
      }
      window.addEventListener('resize', syncControls, { passive: true });

      root.addEventListener('mouseenter', function () { hoverPaused = true; stopTimer(); });
      root.addEventListener('mouseleave', function () { hoverPaused = false; startTimer(); });
      root.addEventListener('touchstart', function () { stopTimer(); }, { passive: true });
      root.addEventListener('touchend', function () { setTimeout(startTimer, 1500); }, { passive: true });

      // Do not run (or play videos) while the hero is off screen
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) { playActive(); startTimer(); } else { stopTimer(); slides.forEach(function (s) { s.querySelectorAll('video').forEach(function (v) { v.pause(); }); }); }
        }, { threshold: 0.25 }).observe(root);
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) stopTimer(); else startTimer(); });
      phone.addEventListener && phone.addEventListener('change', function () { playActive(); });

      setCurrent(0);
    }
    function boot() { document.querySelectorAll('[data-ssh]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target && e.target.closest && e.target.closest('[data-ssh-slide]');
      var root = slide && slide.closest('[data-ssh]');
      if (!root) return;
      var vp = root.querySelector('.ssh__viewport');
      var idx = [].indexOf.call(root.querySelectorAll('[data-ssh-slide]'), slide);
      vp.scrollTo({ left: idx * vp.clientWidth * (getComputedStyle(vp).direction === 'rtl' ? -1 : 1), behavior: 'auto' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-policy-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__sspInit) return;
      root.__sspInit = true;
      var links = root.querySelectorAll('[data-ssp-link]');
      if (!links.length) return;
      var map = {};
      links.forEach(function (a) { map[a.getAttribute('data-ssp-link')] = a; });
      function setActive(id) {
        links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-ssp-link') === id); });
        var a = map[id];
        var list = a && a.closest('.ssp-nav__list');
        if (a && list && list.scrollWidth > list.clientWidth) {
          list.scrollTo({ left: a.offsetLeft - 20, behavior: 'smooth' });
        }
      }
      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          var t = document.getElementById(a.getAttribute('data-ssp-link'));
          if (!t) return;
          e.preventDefault();
          t.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          if (history.replaceState) history.replaceState(null, '', '#' + t.id);
          setActive(t.id);
        });
      });
      var ids = Object.keys(map);
      var targets = ids.map(function (id) { return document.getElementById(id); }).filter(Boolean);
      if (!targets.length) return;
      setActive(targets[0].id);
      if (!('IntersectionObserver' in window)) return;
      var visible = {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible[en.target.id] = en.isIntersecting; });
        for (var i = 0; i < targets.length; i++) {
          if (visible[targets[i].id]) { setActive(targets[i].id); return; }
        }
      }, { rootMargin: '-120px 0px -60% 0px' });
      targets.forEach(function (t) { io.observe(t); });
    }
    function boot() { document.querySelectorAll('[data-ssp]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-shop-by-colour"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initNav(root) {
      var vp = root.querySelector('.ssc__viewport');
      var prev = root.querySelector('.ssc__nav-btn--prev');
      var next = root.querySelector('.ssc__nav-btn--next');
      if (!vp || !prev || !next) return;
      var mq = window.matchMedia('(min-width: 991px)');
      function step() { var t = vp.querySelector('.ssc__tile:not([hidden])'); return t ? t.offsetWidth : vp.clientWidth * 0.2; }
      function update() {
        if (!mq.matches) { prev.hidden = next.hidden = true; prev.classList.remove('is-visible'); next.classList.remove('is-visible'); return; }
        var max = vp.scrollWidth - vp.clientWidth, pos = Math.abs(vp.scrollLeft), can = max > 4;
        prev.hidden = next.hidden = !can;
        prev.classList.toggle('is-visible', can && pos > 4);
        next.classList.toggle('is-visible', can && pos < max - 4);
      }
      function sign() { return getComputedStyle(vp).direction === 'rtl' ? -1 : 1; }
      prev.addEventListener('click', function () { vp.scrollBy({ left: -sign() * step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { vp.scrollBy({ left: sign() * step(), behavior: 'smooth' }); });
      vp.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      if (mq.addEventListener) mq.addEventListener('change', update);
      update();
    }
    function init(root) {
      if (root.__sscInit) return;
      root.__sscInit = true;
      var tabs = [].slice.call(root.querySelectorAll('[data-ssc-tab]'));
      initNav(root);
      if (!tabs.length) return;
      var tiles = [].slice.call(root.querySelectorAll('.ssc__tile'));
      var grid = root.querySelector('[data-ssc-grid]');
      var pass = root.getAttribute('data-gender-pass') === 'true';
      var param = root.getAttribute('data-gender-param') || 'filter.p.product_type';
      var values = { women: root.getAttribute('data-gender-women') || 'Women', men: root.getAttribute('data-gender-men') || 'Men' };
      // the colour links carry the chosen Women / Men as a filter, so the collection opens already filtered
      function link(tile, which) {
        if (!pass || tile.tagName !== 'A') return;
        var base = tile.getAttribute('data-base') || tile.getAttribute('href');
        var aud = tile.getAttribute('data-aud');
        var g = aud === 'both' ? which : aud;
        tile.setAttribute('href', base + (base.indexOf('?') === -1 ? '?' : '&') + param + '=' + encodeURIComponent(values[g] || ''));
      }
      function show(which) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-ssc-tab') === which;
          t.classList.toggle('active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
        });
        tiles.forEach(function (tile) {
          var aud = tile.getAttribute('data-aud');
          tile.hidden = !(aud === 'both' || aud === which);
          link(tile, which);
        });
        if (grid) { grid.style.scrollBehavior = 'auto'; grid.scrollLeft = 0; grid.style.scrollBehavior = ''; grid.dispatchEvent(new Event('scroll')); }
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(t.getAttribute('data-ssc-tab')); });
        t.addEventListener('keydown', function (e) {
          var dir = document.documentElement.dir === 'rtl' ? -1 : 1;
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + dir + tabs.length) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - dir + tabs.length) % tabs.length];
          if (next) { e.preventDefault(); next.focus(); show(next.getAttribute('data-ssc-tab')); }
        });
      });
    }
    function boot() { document.querySelectorAll('[data-ssc]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-stores"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__sstInit) return;
      root.__sstInit = true;
      var vp = root.querySelector('.sst__viewport');
      var prev = root.querySelector('.sst__nav-btn--prev');
      var next = root.querySelector('.sst__nav-btn--next');
      if (!vp || !prev || !next) return;
      var mq = window.matchMedia('(min-width: 991px)');
      var phone = window.matchMedia('(max-width: 749px)');
      function step() { if (phone.matches) return vp.clientWidth; var c = vp.querySelector('.sst__store'); return c ? c.offsetWidth : vp.clientWidth / 3; }
      function update() {
        var max = vp.scrollWidth - vp.clientWidth, pos = Math.abs(vp.scrollLeft), can = max > 4;
        prev.hidden = next.hidden = !can;
        prev.classList.toggle('is-visible', can && pos > 4);
        next.classList.toggle('is-visible', can && pos < max - 4);
      }
      function sign() { return getComputedStyle(vp).direction === 'rtl' ? -1 : 1; }
      prev.addEventListener('click', function () { vp.scrollBy({ left: -sign() * step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { vp.scrollBy({ left: sign() * step(), behavior: 'smooth' }); });
      vp.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      if (mq.addEventListener) { mq.addEventListener('change', update); phone.addEventListener('change', update); }
      update();
    }
    function boot() { document.querySelectorAll('[data-sst]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
